export const CustomAuth0Connections = {
	facebook: 'custom-facebook-connection',
	linkedin: 'custom-linkedin-connection'
};

export const Auth0Providers = {
	oauth2: 'oauth2'
};
